// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"cd","backToTop":"cd"};